/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ field: NonNullable<unknown> }} Warning_UnsortableInputs */

const en_warning_unsortable = /** @type {(inputs: Warning_UnsortableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} can hold several values, so it cannot be sorted`)
};

const de_warning_unsortable = /** @type {(inputs: Warning_UnsortableInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.field} kann mehrere Werte haben und lässt sich nicht sortieren`)
};

/**
* | output |
* | --- |
* | "{field} can hold several values, so it cannot be sorted" |
*
* @param {Warning_UnsortableInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const warning_unsortable = /** @type {((inputs: Warning_UnsortableInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Warning_UnsortableInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_warning_unsortable(inputs)
	return en_warning_unsortable(inputs)
});